export function getAuth (state: Insite.AppState) {
  return state.auth
}
